import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend'; // 👈 Добавить
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(Backend) // 👈 Добавить
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    debug: true,
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: '/locales/{{lng}}/translation.json', // 👈 Где хранятся переводы
    },
  });

export default i18n;
